import { render } from "./Destination.vue?vue&type=template&id=cba24ee6&scoped=true"
import script from "./Destination.vue?vue&type=script&lang=js"
export * from "./Destination.vue?vue&type=script&lang=js"

import "./Destination.vue?vue&type=style&index=0&id=cba24ee6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cba24ee6"]])

export default __exports__